import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "axios";
import jwt_decode from "jwt-decode";

const url = process.env.REACT_APP_API_URL;
const url_open = process.env.REACT_APP_OPEN_API_URL;

export const clearUserState = createAction("auth/clearUserState");

export const loginUser = createAsyncThunk(
  "auth/login",
  //async (values, { rejectWithValue }) => { changed 6
  async ({ values, rememberMe }, { rejectWithValue }) => {
    try {
      // console.log(`Attemping post to newlogin - ${url}/auth/login`);
      console.log(rememberMe);
      let body = {
        userEmail: values.email,
        userPassword: values.password,
        rememberMe: rememberMe,
      };
      let headers = {
        // TODO: Include the X-Api-Key
        // TODO: Add the JWT
      };
      var response3 = await axios.post(`${url_open}/auth/login`, body, {
        headers,
      });
      // console.log(`response3 status from login - ${response3?.status}`);
      // console.log(`JSON.stringify(response3.data.data) - ${JSON.stringify(response3?.data?.data)}`)
      if (
        response3 !== null &&
        response3?.status !== null &&
        response3?.data?.data !== null &&
        rememberMe === true
      ) {
        //console.log(`response3?.data?.data['refresh'] - ${response3?.data?.data['refresh']}`)
        // console.log(`response3?.data?.data['token'] - ${response3?.data?.data['token']}`)
        // console.log(`response3?.data?.data['apiKey'] - ${response3?.data?.data['apiKey']}`)
        // console.log(`response3?.data?.data['authorized'] - ${response3?.data?.data['authorized']}`)
        return [
          response3?.data?.data["user"],
          response3?.status,
          response3?.data?.data["token"],
          response3?.data?.data["apiKey"],
          rememberMe,
          response3?.data?.data["refresh"],
        ];
      } else if (
        response3 !== null &&
        response3?.status !== null &&
        response3?.data?.data !== null &&
        rememberMe === false
      ) {
        console.log("User logged in without storing response in Redux store");
        return [
          response3?.data?.data["user"],
          response3?.status,
          response3?.data?.data["token"],
          response3?.data?.data["apiKey"],
          rememberMe,
        ];
      } else {
        return rejectWithValue([null, response3?.status, `Unexpected error!`]);
      }
    } catch (ex) {
      return rejectWithValue([null, ex.response.status, ex.message]);
    }

    // try {
    //     console.log(`axios post - ${url}/auth/login`);
    //     let res = await axios.post(`${url}/auth/login`, {
    //         userEmail: values.email,
    //         userPassword: values.password
    //     });
    //     return [res.data, res.status];
    // } catch ({ response }) {
    //     return rejectWithValue([null, response.status]);
    // }
  }
);

export const logoutUser = createAsyncThunk("auth/logout", async () => {
  try {
    let res = await axios.get(`${url}/auth/logout`);
    sessionStorage.clear();
    return [res.data, res.status];
  } catch (err) {
    return err;
  }
});

export const checkUByEmAndPass = createAsyncThunk(
  "user/checkUByEmAndPass",
  async (values) => {
    try {
      console.log(`Passed in values - ${values}`);
      let res = await axios.post(`${url}/user/checkUByEmAndPass`, values);
      return [res.data, res.status];
    } catch (err) {
      return err;
    }
  }
);

export const getUser = createAsyncThunk(
  "auth/getUser",
  async (_, { rejectWithValue }) => {
    try {
      let res = await axios.get(`${url}/auth/getUser`, {
        withCredentials: true,
      });
      console.log("getUser res - ", res);
      if (res.data.message) {
        return rejectWithValue(res.data.message);
      } else {
        return [res.data, res.status];
      }
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response);
    }
  }
);

export const updateUsersTable = createAsyncThunk(
  "user/updateUsersTable",
  async (values, { rejectWithValue }) => {
    try {
      let res = await axios.post(`${url}/users/employ`, {
        UserId: values.UserId,
        EmployeeRecordId: values.EmployeeRecordId,
      });
      return [values.CompanyUEN];
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response);
    }
  }
);

export const deactivateUser = createAsyncThunk(
  "user/deactivateAccount",
  async (values, { rejectWithValue }) => {
    try {
      let res = await axios.patch(`${url}/user/deactivateAccount`, {
        UserId: values.UserId,
      });
      return res;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response);
    }
  }
);

export const GoogleloginUser = createAsyncThunk(
  "auth/Googlelogin",
  //async (values, { rejectWithValue }) => { changed 6
  async (token, { rejectWithValue }) => {
    try {
      var user = jwt_decode(token);
      let body = {
        userEmail: user.email,
        userGivenname: user.given_name,
        userFamilyname: user.family_name,
        GoogleId: user.sub,
        GoogleToken: token,
        //rememberMe: rememberMe
      };
      let headers = {
        // TODO: Include the X-Api-Key
        // TODO: Add the JWT
      };
      var response3 = await axios.post(`${url_open}/auth/Googlelogin`, body, {
        headers,
      });
      // console.log(`response3 status from login - ${response3?.status}`);
      // console.log(`JSON.stringify(response3.data.data) - ${JSON.stringify(response3?.data?.data)}`)
      if (
        response3 !== null &&
        response3?.status !== null &&
        response3?.data?.data !== null
      ) {
        console.log(`response3?.data?.data['status'] - ${response3?.status}`);
        // console.log(`response3?.data?.data['token'] - ${response3?.data?.data['token']}`)
        // console.log(`response3?.data?.data['apiKey'] - ${response3?.data?.data['apiKey']}`)
        // console.log(`response3?.data?.data['authorized'] - ${response3?.data?.data['authorized']}`)
        return [
          response3?.data?.data["user"],
          response3?.status,
          response3?.data?.data["token"],
          response3?.data?.data["apiKey"],
        ];
      } else {
        return rejectWithValue([null, response3?.status, `Unexpected error!`]);
      }
    } catch (ex) {
      return rejectWithValue([null, ex.response.status, ex.message]);
    }

    // try {
    //     console.log(`axios post - ${url}/auth/login`);
    //     let res = await axios.post(`${url}/auth/login`, {
    //         userEmail: values.email,
    //         userPassword: values.password
    //     });
    //     return [res.data, res.status];
    // } catch ({ response }) {
    //     return rejectWithValue([null, response.status]);
    // } 
  }
);

export const updateUserInfo = createAsyncThunk(
  "user/updateUserInfo",
  async (values, { rejectWithValue }) => {
    try {
      // console.log(`Values: ${values}`);
      // console.log(`axios patch url - ${url}/user/updateUserInfo`);
      let res = await axios.patch(`${url}/user/updateUserInfo`, values);
      return res;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response);
    }
  }
);

export const updateUserPfpInfo = createAction("user/updateUserPfpInfo");

export const removeUserPfpInfo = createAction("user/removeUserPfpInfo");
